import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "reorder-up-icon",
  role: "img",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M11.4697 2.55025C11.7626 2.25736 12.2374 2.25736 12.5303 2.55025L18.5699 8.58979C18.8628 8.88268 18.8628 9.35756 18.5699 9.65045C18.277 9.94334 17.8021 9.94334 17.5092 9.65045L12.75 4.89125V17.5014C12.75 17.9156 12.4142 18.2514 12 18.2514C11.5858 18.2514 11.25 17.9156 11.25 17.5014V4.89123L6.49078 9.65045C6.19789 9.94334 5.72301 9.94334 5.43012 9.65045C5.13723 9.35756 5.13723 8.88268 5.43012 8.58979L11.4697 2.55025ZM5.96045 20.1697C5.54624 20.1697 5.21045 20.5055 5.21045 20.9197C5.21045 21.3339 5.54624 21.6697 5.96045 21.6697H18.0345C18.4487 21.6697 18.7845 21.3339 18.7845 20.9197C18.7845 20.5055 18.4487 20.1697 18.0345 20.1697H5.96045Z"
    }, null, -1)
  ])))
}
export default { render: render }